module.exports = __webpack_public_path__ + "static/media/salesSvg.43c509da.svg";